import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreAlertComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreCardComponent } from '../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { EditContactService } from './../../../_services/edit-contact.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, MapfreAlertComponent, MapfreButtonComponent],
  selector: 'app-agent-notification',
  templateUrl: './agent-notification.component.html',
  styleUrls: ['./agent-notification.component.scss'],
})
export class AgentNotificationComponent implements OnInit {
  isACMIC: boolean;
  loader: boolean;
  token: string;

  constructor(
    private acmicService: AcmicService,
    private editContact: EditContactService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isACMIC = this.acmicService.isACMIC();
    this.activatedRoute.queryParams.subscribe((param) => {
      this.token = param['token'];
    });
  }

  unsubscribe() {
    this.editContact.unsubscribeAgent(this.token).subscribe(() => {
      close();
    });
  }

  onCancel() {
    close();
  }
}
